import MenuItem from '@mui/material/MenuItem';
import React, { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import IconButton from '@mui/material/IconButton';
import Avatar from '@mui/material/Avatar';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import MenuList from '@mui/material/MenuList';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import Divider from '@mui/material/Divider';
import { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useApolloClient } from '@apollo/client';
import { CONSTANTS } from '../../constants/constants';
import useSessionStorageService from '../../services/session';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import NRUserIcon from '../../NRIcons/NRUserIcon';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';

function UserAvatar({ ...props }) {
  const { user, isAuthenticated, isLoading, logout } = useAuth0();
  const { clearUserSessionData } = useSessionStorageService();
  const logoutUrl = process.env.REACT_APP_AUTH0_REDIRECT_URL;

  const theme = useTheme();
  const navigate = useNavigate();
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [userObj, setUserObj] = useState(user || null);
  const client = useApolloClient();

  const handleToggle = () => {
    setOpen(!open);
  };

  function handleClose(event) {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  }

  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      setUserObj(user);
    }
  }, [user, isLoading, isAuthenticated]);

  function handleMenuItemClick(event, path) {
    navigate(path);
    handleClose(event);
  }

  return (
    <Box {...props}>
      <IconButton
        ref={anchorRef}
        aria-label="current user account"
        aria-controls="menu-appbar"
        aria-haspopup="true"
        onClick={handleToggle}
        disableRipple
        sx={{
          p: 0,
          cursor: 'pointer',
          zIndex: 0
        }}
      >
        <Avatar
          sx={{
            backgroundColor: theme.palette.text.avatarAlt.background,
            color: theme.palette.text.avatarAlt.color
          }}
          variant="rounded"
        >
          <NRUserIcon />
        </Avatar>
      </IconButton>
      <Popper open={open} anchorEl={anchorRef.current} transition disablePortal>
        {({ TransitionProps, placement }) => (
          <Grow {...TransitionProps} style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}>
            <Paper sx={{ minWidth: 250 }} elevation={3}>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList id="avatar-menu-list-grow">
                  <MenuItem onClick={e => handleMenuItemClick(e, '/profile')}>
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column'
                      }}
                    >
                      <Box
                        component="span"
                        sx={{
                          ...theme.typography.body1
                        }}
                      >
                        {CONSTANTS.ORGANIZATION_TEXT.MY_PROFILE}
                      </Box>
                      <Box
                        component="span"
                        sx={{
                          color: theme.palette.text.secondary
                        }}
                      >
                        {userObj?.email}
                      </Box>
                    </Box>
                  </MenuItem>
                  <Divider
                    sx={{
                      margin: `${theme.spacing(1)} 0`
                    }}
                  />
                  <MenuItem
                    onClick={() => {
                      client.clearStore();
                      clearUserSessionData();
                      !!user &&
                        logout({
                          returnTo: logoutUrl
                        });
                    }}
                  >
                    Log Out
                    <LogoutOutlinedIcon
                      style={{
                        marginLeft: 'auto',
                        color: theme.palette.text.icon
                      }}
                    />
                  </MenuItem>
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </Box>
  );
}
export default UserAvatar;
